module.exports = __webpack_public_path__ + "img/28-produtividade-resumo-acoes.ad37a561.png";